export default __webpack_public_path__ + "static/media/learose-1920w.15351239.webp";